import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
// import "swiper/css";
// import "swiper/css/free-mode";
// import "swiper/css/pagination";
import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.min.css';

import MH from '../archivos/logos/logo_mindhub.png';
import Murchison from '../archivos/logos/logo_murchison-rem.png';
import Newsan from '../archivos/logos/logo_newsan.png';
import EY from '../archivos/logos/logo_ey.png';
import Wemfi from '../archivos/logos/logo_wemfi.png';
import Tecseris from '../archivos/logos/logo_tecseris.png';
import Neuronal from '../archivos/logos/logo_neuronal.png';
import Tiag from '../archivos/logos/logo_tiarg.png';
import Remitee from '../archivos/logos/logo_remitee.png';
import Kelvineu from '../archivos/logos/logo_kelvineu.png';

import './styles/CustomerCarrousel.css';

// import required modules
import { FreeMode, Pagination, Autoplay } from 'swiper';

export default function Carrausel() {
	return (
		<>
			<Swiper
				slidesPerView={1}
				spaceBetween={50}
				freeMode={true}
				pagination={{
					clickable: true,
				}}
				autoplay={{
					delay: 3000,
					disableOnInteraction: false,
				}}
				breakpoints={{
					640: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
					1024: {
						slidesPerView: 4,
						spaceBetween: 80,
					},
				}}
				modules={[FreeMode, Autoplay]}
				className='mySwiper'
			>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={Newsan} alt='Logo de Newsan' />
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={EY} alt='Logo de EY' />
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={Wemfi} alt='Logo de Wemfi' />
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={MH} alt='Logo de Mindhub' />
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={Murchison} alt='Logo de Murchison' />
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={Tecseris} alt='Logo de Tecseris' />
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={Remitee} alt='Logo de Remitee' />
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={Neuronal} alt='Logo de Neuronal' />
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={Tiag} alt='Logo de Tiag' />
					</div>
				</SwiperSlide>
				<SwiperSlide>
					<div className='imgSlider'>
						<img src={Kelvineu} alt='Logo de Kelvineu' />
					</div>
				</SwiperSlide>
			</Swiper>
		</>
	);
}
